import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SnackbarTitle({ className, children }) {
    return <div className={cn('text-sm font-medium', className)}>{children}</div>;
}

SnackbarTitle.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
